import { AuthenticationService } from 'app/core/authentication';
import { DefaultPageRouteService, RouterService } from 'app/core/navigation';
import { Injectable } from '@angular/core';
import { IToken } from 'app/core/authentication/models/token';
import { ITokenResponse } from 'app/core/authentication/models/token-response';
import { IUserClaims } from 'app/core/authentication/models/user-claims';
import { TranslationService } from 'app/core/internationalization/translation.service';
import { UrlService } from 'app/core/http/url.service';
import { TOKEN_STORAGE_KEYS } from '../constants/token-storage-keys';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly defaultRoutingService: DefaultPageRouteService,
    private readonly router: RouterService,
    private readonly translationService: TranslationService,
    private readonly urlService: UrlService) { }

  public convertToToken(tokenResponse: ITokenResponse): IToken {
    return {
      // eslint-disable-next-line camelcase
      access_token: tokenResponse.AuthToken
    };
  }

  public convertToUserClaims(tokenResponse: ITokenResponse): IUserClaims {
    return {
      authMethod: tokenResponse.AuthMethod,
      expiry: tokenResponse.Expiry,
      isTransient: tokenResponse.IsTransient,
      localeId: tokenResponse.LocaleId,
      roles: tokenResponse.Roles,
      userId: tokenResponse.UserId,
      userName: tokenResponse.Username
    };
  }

  public setTokenResponse(tokenResponse: ITokenResponse): void {
    const currLocale = this.translationService.getCurrentLanguage();

    this.urlService.setServerApiUrl(tokenResponse.CoreUrl);

    this.authenticationService.setUserClaims(this.convertToUserClaims(tokenResponse));
    this.authenticationService.setTokens(this.convertToToken(tokenResponse));

    const newLocale = this.authenticationService.getUserClaims().localeId;
    this.authenticationService.checkReload(currLocale, newLocale);
  }

  public redirectOnSuccess(skipRedirectToDefaultPage?: boolean): void {
    const redirectEDUrl = sessionStorage.getItem(TOKEN_STORAGE_KEYS.POST_EDLINK_REDIRECT);
    if (redirectEDUrl) {      
        sessionStorage.removeItem(TOKEN_STORAGE_KEYS.POST_EDLINK_REDIRECT);
        this.router.navigateByUrl(redirectEDUrl, { replaceUrl: true });      
    }
    else {
      const redirectUrl = this.authenticationService.getInterruptedUrl();
      if (redirectUrl) {
        this.authenticationService.setInterruptedUrl('');
        this.router.navigateByUrl(redirectUrl, { replaceUrl: true });
      } else if (!skipRedirectToDefaultPage) {
        this.defaultRoutingService.routeToDefaultPage();
      }
    }
  }
}
